"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var info_svg_1 = __importDefault(require("../../../assets/icons/avisos/info.svg"));
var error_svg_1 = __importDefault(require("../../../assets/icons/avisos/error.svg"));
var report_svg_1 = __importDefault(require("../../../assets/icons/avisos/report.svg"));
var warning_svg_1 = __importDefault(require("../../../assets/icons/avisos/warning.svg"));
var block_svg_1 = __importDefault(require("../../../assets/icons/avisos/block.svg"));
var cancel_svg_1 = __importDefault(require("../../../assets/icons/avisos/cancel.svg"));
var check_circle_svg_1 = __importDefault(require("../../../assets/icons/avisos/check_circle.svg"));
var emergency_home_svg_1 = __importDefault(require("../../../assets/icons/avisos/emergency_home.svg"));
var help_svg_1 = __importDefault(require("../../../assets/icons/avisos/help.svg"));
var notifications_svg_1 = __importDefault(require("../../../assets/icons/avisos/notifications.svg"));
var upcoming_svg_1 = __importDefault(require("../../../assets/icons/avisos/upcoming.svg"));
var Avisos = {
    "info": info_svg_1.default,
    "error": error_svg_1.default,
    "report": report_svg_1.default,
    "warning": warning_svg_1.default,
    "block": block_svg_1.default,
    "cancel": cancel_svg_1.default,
    "check_circle": check_circle_svg_1.default,
    "emergency_home": emergency_home_svg_1.default,
    "help": help_svg_1.default,
    /* check_circle renomeado */
    "success": check_circle_svg_1.default,
    "notifications": notifications_svg_1.default,
    "upcoming": upcoming_svg_1.default,
};
exports.default = Avisos;
